import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Image",
          value: "inventoryImage",
        },
        {
          text: "Item",
          value: "Item.name",
        },
        {
          text: "Key",
          value: "Item.key",
        },
        {
          text: "Status",
          value: "shopItemStatus",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Price",
          value: "inventoryPrice",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: "Image",
          value: "inventoryImage",
        },
        {
          text: "Item",
          value: "Item.name",
        },
        {
          text: "Key",
          value: "Item.key",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Price",
          value: "inventoryPrice",
        },
        {
          text: "Status",
          value: "shopItemStatus",
        },
        {
          text: i18n.t("model.prop.start"),
          value: "timestampStart",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.end"),
          value: "timestampEnd",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "model",
        key: "itemId",
        server: "game",
        name: "Item",
        model: "item",
        optionValue: "id",
        defaultValue: 1,
      },
      {
        type: "number",
        key: "quantity",
        name: "Quantity",
        min: 0,
        defaultValue: 1,
      },
    ],
    rules: {
      itemId: [(v) => !!v || "Item is required"],
      quantity: [(v) => !!v || "Quantity is required"],
    },
  },
  edit: false,
  delete: true,
};
